import React from "react";
import Slider from "./Slider";
export const Header = (props) => {
  return (
    <header id="header">
      <div className="xs:pt-[78px] sm:pt-[78px] md:pt-[57px]">
        <Slider />
      </div>
    </header>
  );
};
